
import { Outlet } from 'react-router-dom'
import FooterComponent from './FooterComponent'

const HeaderComponent = () => {

  return (
    <>

      <main className='main text-[rgb(51,51,51)]' role='main'>

        <Outlet />

      </main>

      <FooterComponent />

    </>
  )
}


export default HeaderComponent